var map = {
	"./add_balance.svg": 45031,
	"./bank_transfer_eur.svg": 42366,
	"./bank_transfer_inr.svg": 24923,
	"./bank_transfer_usd.svg": 41722,
	"./btc.svg": 97018,
	"./capitalist_usd.svg": 71100,
	"./other.svg": 93177,
	"./paypal_eur.svg": 93229,
	"./skrill_usd.svg": 90249,
	"./usdc_bep_20.svg": 64123,
	"./usdc_erc_20.svg": 17152,
	"./usdc_trc_20.svg": 91687,
	"./usdt_erc_20.svg": 37833,
	"./usdt_trc_20.svg": 45442
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14636;